import { render, staticRenderFns } from "./leadDetail.vue?vue&type=template&id=4a2fc71a&scoped=true&"
import script from "./leadDetail.vue?vue&type=script&lang=js&"
export * from "./leadDetail.vue?vue&type=script&lang=js&"
import style0 from "./leadDetail.vue?vue&type=style&index=0&id=4a2fc71a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2fc71a",
  null
  
)

export default component.exports